/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Exception_No_MeetingsInputs */



/**
* | output |
* | --- |
* | "No upcoming meetings on your calendar." |
*
* @param {Meetings_Exception_No_MeetingsInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_exception_no_meetings = /** @type {((inputs?: Meetings_Exception_No_MeetingsInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Exception_No_MeetingsInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Geen komende gesprekken in je agenda.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune conversation à venir dans votre agenda.")
	return /** @type {LocalizedString} */ ("No upcoming meetings on your calendar.")
});